import dayjs from "dayjs";

export const oldest = (dates: Array<string>) =>
  dates.reduce((min, curr) => {
    return dayjs(curr).isBefore(dayjs(min)) ? curr : min;
  });
